export default __webpack_public_path__ + "static/media/service-Human-Resources-Legal.bb74cf20.jpg";